import { APP_STORE_BUNDLE_IDS } from "@/helpers/constants";
import { actions as appModule } from "@/store/modules/app";

const PERSONAL_ACCOUNT = 'personal_account' // person account doesn't have any bundles, needs custom logic
const ANY_PLAN = [
    APP_STORE_BUNDLE_IDS.TRIAL,
    APP_STORE_BUNDLE_IDS.SOLO,
    APP_STORE_BUNDLE_IDS.TEAM,
    APP_STORE_BUNDLE_IDS.ENTERPRISE,
] // excludes companies with expired plans



export const FEATURE_ADD_COMPANY_MEMBERS = 'add_company_members'
export const FEATURE_CLIENT_ADD = 'client_add'
export const FEATURE_CLIENT_IMPORT = 'client_import'
export const FEATURE_CLIENT_BULK_ACTIONS = 'client_bulk_actions'
export const FEATURE_CUSTOM_FIELDS = 'custom_fields'
export const FEATURE_VIEW_APP_STORE = 'view_app_store'
export const FEATURE_ADD_TASK_CLIENT = 'add_task_client'
export const FEATURE_WORK_ON_EXISTING_TASK = 'work_on_existing_task'
export const FEATURE_ADD_INVOICE = 'add_invoice'
export const FEATURE_ADD_CONTRACT = 'add_contract'

const FEATURES = {
    [FEATURE_ADD_COMPANY_MEMBERS]:{
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
            ], account)
        }
    },
    [FEATURE_CLIENT_ADD]:{
        validate(account){
            return genericValidate([
                PERSONAL_ACCOUNT,
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
            ], account)
        }
    },
    [FEATURE_CLIENT_IMPORT]:{
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
            ], account)
        }
    },
    [FEATURE_CLIENT_BULK_ACTIONS]:{
        validate(account){
            return genericValidate([
                PERSONAL_ACCOUNT,
                ...ANY_PLAN
            ], account)
        }
    },
    [FEATURE_CUSTOM_FIELDS]:{
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
            ], account)
        }
    },
    [FEATURE_VIEW_APP_STORE]:{
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
                PERSONAL_ACCOUNT
            ], account)
        }
    },
    [FEATURE_ADD_TASK_CLIENT]:{
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
                PERSONAL_ACCOUNT
            ], account)
        }
    },
    [FEATURE_WORK_ON_EXISTING_TASK]: {
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
                PERSONAL_ACCOUNT
            ], account)
        }
    },
    [FEATURE_ADD_INVOICE]: {
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
                PERSONAL_ACCOUNT
            ], account)
        }
    },
    [FEATURE_ADD_CONTRACT]: {
        validate(account){
            return genericValidate([
                APP_STORE_BUNDLE_IDS.TRIAL,
                APP_STORE_BUNDLE_IDS.TEAM,
                APP_STORE_BUNDLE_IDS.ENTERPRISE,
                PERSONAL_ACCOUNT
            ], account)
        }
    }
}

function genericValidate(allowed_for_plans, account) {
    if (allowed_for_plans.includes(PERSONAL_ACCOUNT) && account.type === 'person') {
        return true
    }
    return account.bundles.some(bundle_id => allowed_for_plans.includes(bundle_id))
}

export function isFeatureAllowed(feature_name, account) {
    if(account.is_demo) return true
    return FEATURES[feature_name].validate(account)
}

export function validateFeatureAllowed(feature_name, account) {
    if (!isFeatureAllowed(feature_name, account)) {
        appModule.showFeatureNotEnabled(account)
        throw Error('Not allowed')
    }
}
